import { render, staticRenderFns } from "./LinkClients.vue?vue&type=template&id=04c6a394&scoped=true&lang=pug&"
import script from "./LinkClients.vue?vue&type=script&lang=js&"
export * from "./LinkClients.vue?vue&type=script&lang=js&"
import style0 from "./LinkClients.vue?vue&type=style&index=0&id=04c6a394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c6a394",
  null
  
)

export default component.exports